module.exports = __webpack_public_path__ + "img/01_Akademie_Allgemein.44dd9116.jpg";